angular
  .module('contrast.rules.cve')
  .controller(
    'CveShieldDrilldownCtrl',
    function (
      $scope,
      $timeout,
      $routeParams,
      $uibModal,
      $translate,
      permissions,
      ErrorService,
      PromiseService,
      LoadFilterRouteService,
      ProtectionRulesFactory,
      PROTECTION_MODES_BASE
    ) {
      var translGlobal = {
        allImportanceTypes: $translate.instant('title_all_importanceTypes')
      }

      var _searchKeywords = ''
      var numPerLoaded = 15
      var lastSearch = {}
      var ruleId = $routeParams.cveShieldId

      angular.extend($scope, {
        selectedApps: [],
        quickFilters: [],
        selectedQuickFilter: {
          name: translGlobal.allImportanceTypes,
          filterType: 'ALL',
          count: '?'
        },
        appPromise: undefined,

        searchKeywords: searchKeywords,

        model: {
          busy: false,
          selectAllCheckbox: false,
          row: 'appName',
          modes: PROTECTION_MODES_BASE,
          total: undefined
        },
        data: {
          name: '',
          description: '',
          apps: []
        },
        link_mergeApplications: $translate.instant('link_mergeApplications')
      })

      angular.extend($scope, {
        openChangeModeModal: openChangeModeModal,
        toggleSelection: toggleSelection,
        onSelectAll: onSelectAll,
        order: order,
        quickFilterSelect: quickFilterSelect,
        loadByScroll: loadByScroll,
        moveToServer: moveToServer,
        typeSelected: typeSelected,
        hasAppPermission: hasAppPermission,
        hasPermissionAllApps: hasPermissionAllApps
      })

      function init() {
        _loadFilters().then(function () {
          _loadApps(0, numPerLoaded)
        })
      }

      function _loadFilters() {
        return ProtectionRulesFactory.getCveShieldFilters(ruleId, {
          q: _searchKeywords
        }).then(
          function (response) {
            var quickFilters = response.data.filters
            $scope.quickFilters = quickFilters

            $scope.selectedQuickFilter = $scope.quickFilters.find(function (
              filter
            ) {
              return filter.filterType == $scope.selectedQuickFilter.filterType
            })

            $scope.model.total = $scope.selectedQuickFilter.count
          },
          function (response) {
            ErrorService.processError(response)
          }
        )
      }

      function _loadApps(offset, limit) {
        if ($scope.appPromise) {
          PromiseService.cancelPromise($scope.appPromise)
        }

        $scope.data.busy = true

        var params = {
          quickFilter: $scope.selectedQuickFilter.filterType,
          q: _searchKeywords,
          limit: limit,
          offset: offset,
          sort: $scope.model.row
        }

        lastSearch = ProtectionRulesFactory.getCveShieldDrilldown(
          ruleId,
          params
        )

        lastSearch.then(
          function (response) {
            $scope.data.busy = false
            $scope.data.name = response.data.name
            $scope.data.can_block = response.data.can_block
            $scope.data.description = response.data.description

            if ($scope.model.selectAllCheckbox) {
              angular.forEach(response.data.applications, function (app) {
                app.selected = true
                $scope.selectedApps.push(app)
              })
            }

            angular.forEach(response.data.applications, function (app) {
              permissions.updateAppPermissions(app.app_id, app.allowed_roles)
            })

            $scope.data.apps = $scope.data.apps.concat(
              response.data.applications
            )

            $timeout(function () {
              $scope.$emit('triggerScrollCheck')
            })
          },
          function (response) {
            $scope.data.busy = false
            ErrorService.processError(response)
          }
        )

        $scope.appPromise = lastSearch
      }

      function searchKeywords(newSearchKeywords) {
        if (!arguments.length) {
          return _searchKeywords
        }

        if (newSearchKeywords !== _searchKeywords) {
          _searchKeywords = newSearchKeywords
        }

        $scope.selectedApps = []
        $scope.data.apps = []

        _loadFilters().then(function () {
          _loadApps(0, numPerLoaded)
        })
        return _searchKeywords
      }

      function openChangeModeModal() {
        var modalInstance = $uibModal.open({
          templateUrl: 'views/applications/settings/protection_modal.html',
          controller: 'ModalProtectionRuleModalCtrl',
          size: 'md-sm',
          resolve: {
            appIds: function () {
              return _.map($scope.selectedApps, 'app_id')
            },
            ruleId: function () {
              return ruleId
            },
            callback: function () {
              return resetApps
            },
            enabledBP: function () {
              return false
            },
            canBlock: function () {
              return $scope.data.can_block
            }
          }
        })

        modalInstance.result.then(function () {
          $scope.selectedApps = []
          $scope.data.apps = []
          _loadApps(0, numPerLoaded)
        })
      }

      function onSelectAll() {
        if ($scope.model.selectAllCheckbox) {
          _selectAll()
        } else {
          _deselectAll()
        }
      }

      function _selectAll() {
        $scope.selectedApps = []
        angular.forEach($scope.data.apps, function (app) {
          app.selected = true
          $scope.selectedApps.push(app)
        })

        return $scope.selectedApps
      }

      function _deselectAll() {
        $scope.selectedApps = []
        angular.forEach($scope.data.apps, function (app) {
          app.selected = false
        })

        return $scope.selectedApps
      }

      function toggleSelection(app) {
        var idx = $scope.selectedApps.indexOf(app)

        if (idx > -1) {
          $scope.selectedApps.splice(idx, 1)
        } else {
          $scope.selectedApps.push(app)
        }
        if ($scope.selectedApps.length != $scope.model.total) {
          $scope.model.selectAllCheckbox = false
        } else {
          $scope.model.selectAllCheckbox = true
        }

        return $scope.selectedApps
      }

      function order(rowName) {
        if ($scope.data.row === rowName) {
          return
        }

        $scope.model.row = rowName
        $scope.selectedApps = []
        $scope.data.apps = []
        _loadApps(0, numPerLoaded)
      }

      function quickFilterSelect(filter) {
        $scope.selectedApps = []
        $scope.data.apps = []
        $scope.model.selectAllCheckbox = false

        $scope.selectedQuickFilter = filter
        $scope.model.total = $scope.selectedQuickFilter.count

        _loadApps(0, numPerLoaded)
      }

      function loadByScroll() {
        $scope.model.busy = true
        if ($scope.data.apps.length < $scope.model.total) {
          _loadApps($scope.data.apps.length, numPerLoaded)
        }
      }

      function moveToServer(appId, env) {
        LoadFilterRouteService.goToServersFilteredByApp(appId, env)
      }

      function typeSelected(app, model, environment) {
        var index = _.findIndex(PROTECTION_MODES_BASE, function (mode) {
          return mode.value == model
        })
        ProtectionRulesFactory.editEnvProtectionLevel(
          app.app_id,
          ruleId,
          environment,
          index
        ).catch(function (response) {
          ErrorService.processError(response)
        })
      }

      function resetApps() {
        $scope.selectedApps = []
        $scope.data.apps = []
        _loadApps(0, numPerLoaded)
      }

      function hasAppPermission(application, permission) {
        if (application) {
          return permissions.hasAppPermission(application.app_id, permission)
        }
        return false
      }

      function hasPermissionAllApps(apps, permission) {
        return permissions.hasPermissionToApps(apps, permission)
      }

      init()
    }
  )
